export default "__VITE_ASSET__Djp7RKUx__"